import React from "react";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
const AddtoCart = ({ product, selectedColor }) => {
  const { t } = useTranslation();
  const addToCart = (product, selectedColor) => {
    const selectedColorNormalized = selectedColor
      ? selectedColor.toLowerCase().trim()
      : "default"; // <-- Burayı değiştirdik

    const selectedVariation =
      selectedColorNormalized !== "default"
        ? product.color_images.find(
            (variation) =>
              variation.name.toLowerCase() === selectedColorNormalized
          )
        : null;

    const productWithVariation = {
      ...product,
      selectedVariation: selectedVariation || {
        name: "Default",
        images: product.default_images || [],
      },
    };

    const cart = JSON.parse(localStorage.getItem("cart")) || [];

    // Sepetteki ürünü bul
    const existingProductIndex = cart.findIndex(
      (item) =>
        item.id === productWithVariation.id &&
        item.selectedVariation.name.toLowerCase() === selectedColorNormalized
    );

    if (existingProductIndex > -1) {
      // Eğer ürün zaten sepette var ise, miktarını kontrol et
      if (cart[existingProductIndex].quantity < 3) {
        cart[existingProductIndex].quantity += 1;
      } else {
        Swal.fire({
          icon: "warning",
          title: "Limit Reached",
          text: "You can only add up to 3 of the same product!",
          confirmButtonText: "Okay",
        });
        return; // Ürünü sepete eklemeyi durdur
      }
    } else {
      // Eğer ürün sepette yoksa, yeni ekle
      cart.push({ ...productWithVariation, quantity: 1 });
    }

    localStorage.setItem("cart", JSON.stringify(cart));

    window.dispatchEvent(new Event("cartUpdated"));

    Swal.fire({
      icon: "success",
      title: "Product added to cart",
      toast: true,
      position: "bottom-end",
      showConfirmButton: false,
      timer: 1500,
    });
  };

  return (
    <button
      className="btn fw-14 bgcolorfooterbottom w-100 p-2 fw-normal mb-1"
      onClick={() => addToCart(product, selectedColor)} // Passing the selected color and product to the function
    >
      <i className="fa-solid fa-cart-plus me-2"></i> {t("Add to Cart")}
    </button>
  );
};

export default AddtoCart;
